module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "codemirrorWrapper",
    class: {
      editing: _vm.editing
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('input', {
    staticClass: "name",
    class: {
      sbTitle: !_vm.editing
    },
    attrs: {
      "placeholder": "文件名(带后缀名，高亮检查)",
      "disabled": !_vm.editing
    },
    domProps: {
      "value": _vm.title
    },
    on: {
      "input": _vm.titleChange
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSelfCodePage),
      expression: "isSelfCodePage"
    }],
    staticClass: "edit"
  }, [_c('span', {
    on: {
      "click": _vm.edit
    }
  }, [_vm._v(_vm._s(_vm.editOrDone))]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.alertShow = true
      }
    }
  }, [_vm._v("删除")])])]), _vm._v(" "), _c('v-codemirror', {
    attrs: {
      "options": _vm.cmOptions,
      "value": _vm.code
    },
    on: {
      "input": _vm.onCmCodeChange
    }
  }), _vm._v(" "), _c('v-Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alertShow),
      expression: "alertShow"
    }],
    attrs: {
      "info": "确认删除此片段？"
    },
    on: {
      "confirm": _vm.confirm,
      "cancel": function($event) {
        _vm.alertShow = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39feadac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/code/codeMirror/codeMirror.vue
// module id = 263
// module chunks = 1